{
  "name": "Name",
  "relationship": "Relationship",
  "dob": "Date of Birth",
  "AUTHORIZED_INDIVIDUAL": "Authorized Individual",
  "BENEFICIAL_OWNER": "Beneficial Owner",
  "PRIMARY_BENEFICIARY": "Beneficiary",
  "CONTINGENT_BENEFICIARY": "Contingent Beneficiary",
  "SPOUSE_OR_COMMON_LAW_PARTNER": "Spouse or Common-law Partner",
  "CONTRIBUTOR": "Contributor",
  "SUCCESSOR": "Successor",
  "JOINT": "Joint",
  "DIRECTOR": "Director",
  "POWER_OF_ATTORNEY": "Power of Attorney",
  "TRUSTEE": "Trustee",
  "GRANTOR": "Grantor",
  "PROTECTOR": "Protector",
  "SETTLOR": "Settlor",
  "THIRD_PARTY": "Third Party",
  "OTHER": "Other",
  "GUARDIAN": "Guardian",
  "PRIMARY_CAREGIVER": "Primary Caregiver",
  "DECEDENT": "Decedent",
  "SENIOR_OFFICER": "Senior Officer",
  "accountHolderRelationshipLabel": "I, {{accountHolderFirstName}} {{accountHolderLastName}}, am the {{affiliationType}} of this {{targetType}}.",
  "selectAlternativeLabel": "Select an alternative {{affiliationType}}",
  "addNewAffiliate": "Add new affiliate",
  "addAffiliate": "Add affiliate",
  "saveAffiliate": "Save affiliate",
  "assignAccountHoldersAddress": "Address is same as account holder",
  "noLinkedAffiliate": "There is no {{type}} linked to this account",
  "allocation": "Allocation",
  "grantAmount": "Grant Amount",
  "contributionAmount": "Contribution Amount",
  "gender": "Gender",
  "contactSupport": "To make changes, please contact support",
  "noLinkedAffiliateType": {
    "AUTHORIZED_INDIVIDUAL": "Authorized Individual",
    "BENEFICIAL_OWNER": "Beneficial Owner",
    "PRIMARY_BENEFICIARY": "Beneficiary",
    "CONTINGENT_BENEFICIARY": "Contingent Beneficiary",
    "CONTRIBUTOR": "Contributor",
    "SUCCESSOR": "Successor",
    "JOINT": "Joint Account Holder",
    "POWER_OF_ATTORNEY": "Individual with Power of Attorney",
    "TRUSTEE": "Trustee",
    "SETTLOR": "Settlor",
    "OTHER": "Other Affiliate",
    "DIRECTOR": "Director",
    "GRANTOR": "Grantor",
    "PROTECTOR": "Protector",
    "THIRD_PARTY": "Third Party",
    "DECEDENT": "Decedent",
    "SENIOR_OFFICER": "Senior Officer"
  },
  "button": {
    "AUTHORIZED_INDIVIDUAL": "Add Authorized Individual",
    "BENEFICIAL_OWNER": "Add a Beneficial Owner",
    "PRIMARY_BENEFICIARY": "Add a Beneficiary",
    "CONTINGENT_BENEFICIARY": "Add a Contingent Beneficiary",
    "CONTRIBUTOR": "Add a Contributor",
    "SUCCESSOR": "Add a Successor",
    "JOINT": "Add a Joint Account Holder",
    "POWER_OF_ATTORNEY": "Add an Individual with Power of Attorney",
    "TRUSTEE": "Add a Trustee",
    "SETTLOR": "Add a Settlor",
    "OTHER": "Add an Affiliate",
    "DIRECTOR": "Add a Director",
    "GRANTOR": "Add a Grantor",
    "PROTECTOR": "Add a Protector",
    "THIRD_PARTY": "Add a Third Party",
    "GUARDIAN": "Add a Guardian",
    "PRIMARY_CAREGIVER": "Add a Primary Caregiver",
    "SPOUSE_OR_COMMON_LAW_PARTNER": "Add Spouse or Common-law Partner",
    "DECEDENT": "Add a Decedent",
    "SENIOR_OFFICER": "Add a Senior Officer",
    "edit": {
      "AUTHORIZED_INDIVIDUAL": "Update Authorized Individual",
      "BENEFICIAL_OWNER": "Update a Beneficial Owner",
      "PRIMARY_BENEFICIARY": "Update a Beneficiary",
      "CONTINGENT_BENEFICIARY": "Update a Contingent Beneficiary",
      "CONTRIBUTOR": "Update a Contributor",
      "SUCCESSOR": "Update a Successor",
      "JOINT": "Update a Joint Account Holder",
      "POWER_OF_ATTORNEY": "Update an Individual with Power of Attorney",
      "TRUSTEE": "Update a Trustee",
      "SETTLOR": "Update a Settlor",
      "OTHER": "Update an Affiliate",
      "DIRECTOR": "Update a Director",
      "GRANTOR": "Update a Grantor",
      "PROTECTOR": "Update a Protector",
      "THIRD_PARTY": "Update a Third Party",
      "GUARDIAN": "Update a Guardian",
      "PRIMARY_CAREGIVER": "Update a Primary Caregiver",
      "SPOUSE_OR_COMMON_LAW_PARTNER": "Update Spouse or Common-law Partner",
      "DECEDENT": "Update a Decedent",
      "SENIOR_OFFICER": "Update a Senior Officer"
    }
  },
  "description": {
    "CASH_JOINT": {
      "JOINT": "An individual who has the legal authority or permission to execute agreements and provide instructions with respect to the joint account."
    },
    "TFSA": {
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder."
    },
    "FHSA": {
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder."
    },
    "RRSP": {
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "SPOUSAL_RRSP": {
      "CONTRIBUTOR": "An individual who makes contributions to a spousal registered retirement savings account or is the source of funds in the spousal registered retirement income fund account.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "LIRA": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "LRSP": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "RLSP": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "RRIF": {
      "OTHER": "One can use the age of a spouse or common-law partner, if younger, to determine the minimum amount payable each year. Once the choice has been made, it cannot be changed.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "SPOUSAL_RRIF": {
      "CONTRIBUTOR": "An individual who makes contributions to a spousal registered retirement savings account or is the source of funds in the spousal registered retirement income fund account.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "LIF": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "PRIF": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "LRIF": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "RLIF": {
      "OTHER": "An individual who may have an interest in the account but is not authorized to make transactions or execute agreements, mostly a spouse or common-law partner.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "RESP_FAMILY": {
      "GUARDIAN": "Parents are usually the legal guardians of the beneficiary. You only need to list one guardian who will consent to the use and sharing of the beneficiary's personal information. If the legal guardian is different from the primary user, they will need to sign an additional form before the RESP account is opened.",
      "PRIMARY_CAREGIVER": "The primary caregiver (PCG) is the person primarily responsible for bringing up the child. Either parent can be named as the primary caregiver. If the PCG, if different from the primary subscriber, they will need to sign an additional form before the RESP account is opened. ",
      "PRIMARY_BENEFICIARY": "The individual for whom the education savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created."
    },
    "RESP_FAMILY_JOINT": {
      "JOINT": "An individual who has the legal authority or permission to execute agreements and provide instructions with respect to the joint account.",
      "GUARDIAN": "Parents are usually the legal guardians of the beneficiary. You only need to list one guardian who will consent to the use and sharing of the beneficiary's personal information. If the legal guardian is different from the primary user, they will need to sign an additional form before the RESP account is opened.",
      "PRIMARY_CAREGIVER": "The primary caregiver (PCG) is the person primarily responsible for bringing up the child. Either parent can be named as the primary caregiver. If the PCG, if different from the primary subscriber, they will need to sign an additional form before the RESP account is opened. ",
      "PRIMARY_BENEFICIARY": "The individual for whom the education savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created."
    },
    "RESP_SINGLE": {
      "GUARDIAN": "Parents are usually the legal guardians of the beneficiary. You only need to list one guardian who will consent to the use and sharing of the beneficiary's personal information. If the legal guardian is different from the primary user, they will need to sign an additional form before the RESP account is opened.",
      "PRIMARY_CAREGIVER": "The primary caregiver (PCG) is the person primarily responsible for bringing up the child. Either parent can be named as the primary caregiver. If the PCG, if different from the primary subscriber, they will need to sign an additional form before the RESP account is opened. ",
      "PRIMARY_BENEFICIARY": "The individual for whom the education savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created."
    },
    "RESP_SINGLE_JOINT": {
      "JOINT": "An individual who has the legal authority or permission to execute agreements and provide instructions with respect to the joint account.",
      "GUARDIAN": "Parents are usually the legal guardians of the beneficiary. You only need to list one guardian who will consent to the use and sharing of the beneficiary's personal information. If the legal guardian is different from the primary user, they will need to sign an additional form before the RESP account is opened.",
      "PRIMARY_CAREGIVER": "The primary caregiver (PCG) is the person primarily responsible for bringing up the child. Either parent can be named as the primary caregiver. If the PCG, if different from the primary subscriber, they will need to sign an additional form before the RESP account is opened. ",
      "PRIMARY_BENEFICIARY": "The individual for whom the education savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created."
    },
    "RESP_ADULT": {
      "PRIMARY_BENEFICIARY": "The individual for whom the education savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created."
    },
    "RDSP": {
      "PRIMARY_BENEFICIARY": "The individual for whom the disability savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created.",
      "PRIMARY_CAREGIVER": "The person primarily responsible for bringing up the child. Either parent can be named as the primary caregiver. Primary Caregiver (PCG) is the eligible individual who is receiving (or would be receiving if qualified) the Canada Child Tax Benefit at the time of the contribution or at the time of the request for the Canada Disability Savings Bond."
    },
    "RDSP_JOINT": {
      "PRIMARY_BENEFICIARY": "The individual for whom the disability savings plan has been opened for. The individual should have a social insurance number and be a resident of Canada at the time the account is being created.",
      "PRIMARY_CAREGIVER": "The person primarily responsible for bringing up the child. Either parent can be named as the primary caregiver. Primary Caregiver (PCG) is the eligible individual who is receiving (or would be receiving if qualified) the Canada Child Tax Benefit at the time of the contribution or at the time of the request for the Canada Disability Savings Bond.",
      "JOINT": "An individual who has the legal authority or permission to execute agreements and provide instructions with respect to the joint account."
    },
    "MARGIN_JOINT": {
      "JOINT": "An individual who has the legal authority or permission to execute agreements and provide instructions with respect to the joint account."
    },
    "CORPORATE_CASH": {
      "AUTHORIZED_INDIVIDUAL": "An individual who has the legal authority or permission to act on behalf of an entity or individual. For individual accounts, this is usually the account holder. The individuals are authorized to execute agreements and provide instructions with respect to the account.",
      "BENEFICIAL_OWNER": "An individual who owns, or exercises direct or indirect control or direction over, 25% or more of the voting securities of the entity (if the entity is a corporation), or who exercises control over the affairs of the entity.",
      "DIRECTOR": "An individual who is a member of the corporation's board of directors and is responsible for overseeing the management and strategic direction of the entity. Directors may have governance responsibilities but do not necessarily have direct authority to manage day-to-day financial transactions unless explicitly authorized.",
      "SETTLOR": "An individual or entity who establishes the trust and legally transfers assets into it. ",
      "SENIOR_OFFICER": "An individual with a high-level management position within the corporation who is authorized to act on behalf of the organization. Common titles include President, Chief Executive Officer (CEO), Chief Financial Officer (CFO)."
    },
    "RRSP_SPOUSAL": {
      "CONTRIBUTOR": "An individual who makes contributions to a spousal registered retirement savings plan account or is the source of funds in the spousal registered retirement income fund account.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "RIF_SPOUSAL": {
      "CONTRIBUTOR": "An individual who makes contributions to a spousal registered retirement savings account or is the source of funds in the spousal registered retirement income fund account.",
      "SUCCESSOR": "The spouse or common-law partner of the account holder at the time of death, who acquires all of the rights of the holder under the arrangement including the right to revoke any beneficiary designation. This spouse or common-law partner becomes the new account holder.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "INFORMAL_TRUST": {
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "INFORMAL_TRUST_JOINT": {
      "JOINT": "An individual who has the legal authority or permission to execute agreements and provide instructions with respect to the joint account.",
      "PRIMARY_BENEFICIARY": "An individual or entity designated to receive assets from a registered account."
    },
    "USA_BROKERAGE": {
      "PRIMARY_BENEFICIARY": "Person(s) to receive assets of an account upon account owner's death."
    },
    "USA_IRA": {
      "PRIMARY_BENEFICIARY": "Person(s) to receive assets of an account upon account owner's death."
    },
    "USA_RO_IRA": {
      "PRIMARY_BENEFICIARY": "Person(s) to receive assets of an account upon account owner's death."
    },
    "USA_RT_IRA": {
      "PRIMARY_BENEFICIARY": "Person(s) to receive assets of an account upon account owner's death."
    },
    "USA_ESA": {
      "PRIMARY_BENEFICIARY": "Person designated to receive the account’s assets for their educational expenses."
    },
    "USA_INH_IRA": {
      "DECEDENT": "An individual who has passed and whose assets have been inherited by the current account holder."
    },
    "USA_INH_RT_IRA": {
      "DECEDENT": "An individual who has passed and whose assets have been inherited by the current account holder."
    }
  },
  "affiliationRelationship": {
    "Primary": "Primary",
    "CHILD": "Child",
    "COMMON_LAW": "Common law",
    "GRANDCHILD": "Grandchild",
    "GRANDPARENT": "Grandparent",
    "GUARDIAN": "Guardian",
    "NEPHEW_NIECE": "Nephew/Niece",
    "OTHER": "Other",
    "PARENT": "Parent",
    "PRIMARY_CAREGIVER": "Primary caregiver",
    "SIBLING": "Sibling",
    "SPOUSE": "Spouse"
  },
  "respBeneficiaryRelation": "Relation",
  "createNewAffliate": "Create new affliate",
  "additionalInfoModal": {
    "title": "Additional information required",
    "body": "We need additional information about the affiliate. Kindly click the button below to update the affiliate's information before we connect them to this account."
  },
  "accountHolder": "Account Holder",
  "primaryHolder": "Primary Holder",
  "secondaryHolder": "Secondary Holder",
  "proceed": "Proceed",
  "primaryEmail": "Primary Email",
  "totalWithJoint": "Total with Joint",
  "accessGranted": "Access Granted",
  "accountOwner": "Account Owner",
  "noAccess": "No Access",
  "useExistingAffiliation": "Use an existing affiliation",
  "userSearchWarning": "Warning: Changes made to this user’s details will update their profile information.",
  "selectExistingUsers": "Select Existing User",
  "createNewUser": "Create New User",
  "selectExistingAffiliation": "Select an existing affiliation",
  "useAccountOwner": "Use account owner",
  "createUsingAccountOwner": "This affiliation is set to the account owner. Navigate to the account owners profile to make changes.",
  "updateUsingAccountOwner": "This affiliation is set to the account owner. Please contact support to assign a different user to this affiliation.",
  "createWithExistingAffiliation": "This user is being used by more than one affiliation. Changes made here will also affect the linked user & affiliation.",
  "updateExistingAffiliation": "This user is being used by more than one affiliation. Changes made here will also affect the linked user & affiliation. Please contact support if you need to assign a different user to this affiliation.",
  "accessDeniedToEditMessage": "This user has already been invited. You no longer have permission to edit their information.",
  "zeroAllocationWarning": "You have not allocated any % to this client",
  "selectionTitle": "{{affiliationType}} Selection",
  "addNewLabel": "Add a new {{affiliationType}}",
  "incompleteAffiliates": "The provided {{ affiliationTypes }} affiliate(s) could not be added / updated. Please make sure they have a completed profile.",
  "affiliateInvitationFailed": "The invitation to the affiliate has failed. Please contact support to resolve this issue.",
  "affiliateInvitationSent": "The invitation to the affiliate has been sent.",
  "affiliateInvitationPending": "The invitation to the affiliate is pending."
}
